import Vue from 'vue'
import Vuex from 'vuex'
import { getHomeInitData, getNewsInitData, getalbumInitData, getspecialInitData, getDetail, getColumnData, albumDetail, getStdData, addMorenNews, getContextSS, getBookNews, getArticleNews, getTreeNews, getNodeNews, getColumnTopMessage } from '@/api/api.js'
import { getDataBookList, getDataArticleList, getDataTreeList, getdataNodeList } from '@/api/api.js'

Vue.use(Vuex)

export function createStore() {
  return new Vuex.Store({
    state: {
      homeData: {}, // //首页的初始化数据
      newsData: {}, // /资讯的初始化数据
      atlasData: {}, // //图集页的初始化数据
      vdoData: {}, // /视频页面的初始化数据
      libraryData: {}, // /文库页面初始化数据
      albumnData: {}, // /专辑初始化数据
      specialData: {}, // //专题初始化数据
      detailData: { 'collectionNOrNot': true }, // ///详情页面数据
      columnData: {}, // //按栏目名字查看的数据
      albumDetailData: {}, // 专辑详情数据
      StdData: {},
      searchData: {}, // 搜索数据
      sourceDetailData: {},
      clolumninit: {}, // 按栏目的初始化
      bookList: [],
      puwenList: [],
      puxiList: [],
      renwuList: []
    },
    actions: {
      // 谱书列表数据
      getDataBookList({ commit }, obj) {
        return getDataBookList(obj).then(res => {
          commit('setDataBookList', res.data.listMapData)
        })
      },
      // 谱文列表数据
      getDataArticleList({ commit }, obj) {
        return getDataArticleList(obj).then(res => {
          commit('setDataArticleList', res.data.listMapData)
        })
      },
      // 谱系列表数据
      getDataTreeList({ commit }, obj) {
        return getDataTreeList(obj).then(res => {
          commit('setDataTreeList', res.data.listMapData)
        })
      },
      // 人物列表数据
      getdataNodeList({ commit }, obj) {
        return getdataNodeList(obj).then(res => {
          commit('setdataNodeList', res.data.listMapData)
        })
      },
      getBookNews({ commit }, obj) {
        return getBookNews(obj).then(res => {
          commit('setsourceData', res.data)
        })
      },
      getColumnTopMessage({ commit }, obj) {
        return getColumnTopMessage(obj).then(res => {
          commit('setclolumninitData', res.data)
        })
      },
      getArticleNews({ commit }, obj) {
        return getArticleNews(obj).then(res => {
          commit('setsourceData', res.data)
        })
      },
      getTreeNews({ commit }, obj) {
        return getTreeNews(obj).then(res => {
          commit('setsourceData', res.data)
        })
      },
      getNodeNews({ commit }, obj) {
        return getNodeNews(obj).then(res => {
          commit('setsourceData', res.data)
        })
      },
      // /首页初始化数据
      getHomeInitData({ commit }) {
        return getHomeInitData().then(res => {
          commit('setHomeData', res.data)
        })
      },
      // /资讯页面初始化数据
      getNewsInitData({ commit }, obj) {
        return getNewsInitData(obj).then(res => {
          commit('setNewsData', res.data)
        })
      },
      // /图集页面初始化数据
      getAtlasInitData({ commit }, obj) {
        return getNewsInitData(obj).then(res => {
          commit('setAtlasData', res.data)
        })
      },
      // /视频页面初始化数据
      getVdoInitData({ commit }, obj) {
        return getNewsInitData(obj).then(res => {
          commit('setVdoData', res.data)
        })
      },
      // /文库页面初始化
      getlibraryInitData({ commit }, obj) {
        return getNewsInitData(obj).then(res => {
          commit('setLibraryData', res.data)
        })
      },
      // /专辑页面初始化数据
      getalbumInitData({ commit }) {
        return getalbumInitData().then(res => {
          commit('setAlbumnData', res.data)
        })
      },
      // /专题初始化数据
      getspecialInitData({ commit }) {
        return getspecialInitData().then(res => {
          commit('setspecialData', res.data)
        })
      },
      // /详情页面的数据
      getDetail({ commit }, obj) {
        return getDetail(obj).then(res => {
          // console.log(res.data)
          commit('setdetailData', res.data)
        })
      },
      // //按照栏目查看的数据
      getColumnData({ commit }, obj) {
        return getColumnData(obj).then(res => {
          commit('setcolumnData', res.data)
        })
      },
      // 专辑详情初始化数据
      albumDetail({ commit }, obj) {
        return albumDetail(obj).then(res => {
          commit('setalbumDrtialData', res.data)
        })
      },
      getStdData({ commit }, obj) {
        return getStdData(obj).then(res => {
          commit('setstdData', res.data)
        })
      },
      addMoreSearch({ commit }, obj) {
        return getContextSS(obj).then(res => {
          commit('setsearchData', res.data)
        })
      }
    },
    mutations: {
      setDataArticleList(state, list) {
        state.puwenList = list
      },
      setDataBookList(state, list) {
        state.bookList = list
      },
      setDataTreeList(state, list) {
        state.puxiList = list
      },
      setdataNodeList(state, list) {
        var str = /^http/
        for (var i = 0; i < list.length; i++) {
          if (!str.test(list[i].COVER)) {
            list[i].COVER = ''
          }
        }
        state.renwuList = list
      },
      setclolumninitData(state, list) {
        state.clolumninit = list
      },
      setsourceData(state, list) {
        state.sourceDetailData = list
      },
      setHomeData(state, list) {
        state.homeData = list
      },
      setNewsData(state, list) {
        state.newsData = list
      },
      setAtlasData(state, list) {
        state.atlasData = list
      },
      setVdoData(state, list) {
        state.vdoData = list
      },
      setLibraryData(state, list) {
        state.libraryData = list
      },
      setAlbumnData(state, list) {
        state.albumnData = list
      },
      setspecialData(state, list) {
        state.specialData = list
      },
      setdetailData(state, list) {
        state.detailData = list
      },
      setcolumnData(state, list) {
        state.columnData = list
      },
      setalbumDrtialData(state, list) {
        state.albumDetailData = list
      },
      setstdData(state, list) {
        state.StdData = list
      },
      setsearchData(state, list) {
        state.searchData = list
      }
    }
  })
}
